module.exports = __webpack_public_path__ + "img/cuisine-half-grey.f24a9c41.png";